import { render } from "./CreateSalesPage.vue?vue&type=template&id=33d73714&scoped=true&ts=true"
import script from "./CreateSalesPage.vue?vue&type=script&lang=ts"
export * from "./CreateSalesPage.vue?vue&type=script&lang=ts"

import "./CreateSalesPage.vue?vue&type=style&index=0&id=33d73714&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33d73714"]])

export default __exports__